import React from 'react';
import { graphql } from 'gatsby';
import Container from '@atoms/Container';
import Accordion from '@atoms/styled-accordion';
import paddingDefault from '@utils/paddingDefault';
import apCaseOnlyTitleTags from '@utils/apCaseOnlyTitleTags';
import { Helmet } from 'react-helmet';
import { StyledButtonAsLink } from '../primitives/styled-button';

const FaqsGrid = ({ data }) => {
    const { faqs } = data;
    const { link, heading } = faqs;

    return (
        <>
            {faqs.questions.length > 0 && (<Helmet>
                <script type="application/ld+json">
                    {`
                        {
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": [
                                ${faqs.questions[0].questions.map(node => {
                                        return `{
                                            "@type": "Question",
                                            "name": "${node.question}",
                                            "acceptedAnswer": {
                                                "@type": "Answer",
                                                "text": "${node.answer.replace(/<a\b[^>]*>(.*?)<\/a>/i, '')}"
                                            }
                                        }`
                                    })
                                }
                            ]
                        }
                    `}
                </script>
            </Helmet>)}
            <Container>
                <div css={[paddingDefault(), styles.flexContainer]}>
                    <div css={styles.fullWidth}>
                        <h2 css={styles.faqHeading}>
                            {heading && (apCaseOnlyTitleTags(heading))}
                        </h2>
                        <Accordion columns={1} faqs={faqs} onMediaContent />
                        {!!link?.href && (
                            <div css={styles.linkWrapper}>
                                <StyledButtonAsLink to={link.href}>{link.title}</StyledButtonAsLink>
                            </div>
                        )}
                    </div>
                </div>
            </Container>
        </>
    )
};

const styles = {
    faqHeading: {
        "marginBottom": "1rem",
        "fontSize": "32px",
        "lineHeight": 1.25,
        "textAlign": "center",
        "@media (min-width: 1024px)": {
            "marginBottom": "1.5rem"
        }
    },
    flexContainer: {
        "@media (min-width: 1024px)": {
            "display": "flex", "flexDirection": "row"
        }
    },
    fullWidth: {
        "@media (min-width: 1024px)": {
            "width": "100%"
        }
    },
    linkWrapper: {
        "display": "flex",
        "marginTop": "2.5rem",
        "@media (min-width: 1024px)": {
            "marginTop": "3rem"
        }
    }
};

export const query = graphql`
  fragment FaqsGridData on CmsPageBuilderBlocks {
    faqs_grid {
      faqs {
        heading
        questions {
          questions {
            question
            answer
          }
        }
        link {
          href
          title
        }
      }
    }
  }
`

export default FaqsGrid;
